export default __webpack_public_path__ + "Content/Images/content/Lake-Pleasant-And-Happy-Valley-Exterior.jpg";